import router from "../Chat/router";
import store from "./store";


export default {
  store,
  router
};